import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FloatingAlert } from '@shared/components/floating-alerts/model/floating-alerts.model';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ac-floating-alert',
  standalone: true,
  imports: [TranslateModule, CustomLinkDirective],
  templateUrl: './floating-alert.component.html',
  styleUrls: ['./floating-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.alert-type]': 'alert.type',
  },
})
export class FloatingAlertComponent {
  @Input({ required: true }) alert!: FloatingAlert;
  protected readonly close = close;

  constructor(private _floatingAlertService: FloatingAlertsService) {}
  public dismiss(): void {
    this._floatingAlertService.remove(this.alert.id);
  }
}
